<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 text-white d-inline-block mb-0">Onboarding</h6>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <b-card no-body>
        <b-card-header>
          <b-row class="mb-4">
            <b-col v-for="(section, index) in sections" :key="index" class="text-center">
              <i :class="'circle-icon fas ' + completed(section) + ' ' + current(section)" @click="currentstep = section.steps[0]"></i>
            </b-col>
          </b-row>
          <base-progress class="mb-0"
                         type="success"
                         :value="progress">
          </base-progress>
        </b-card-header>
        <b-card-body>
          <h2 v-if="currentstep > 0">{{ title[0].title }}</h2>
          <validation-observer v-slot="{handleSubmit}" ref="formValidator">
            <b-form role="form" @submit.prevent="handleSubmit(submit)">
              <div v-show="currentstep == 1">
                <p class="small">The below information is used to calculate multiple values throughout your ClarityNOW portal including the number of days you have left to take a listing and the number of days you have left to close a sale.</p>
                <div class="text-right">
                  <b-dropdown id="how-to-dropdown" text="How To Videos" variant="outline-danger" size="sm">
                    <b-dropdown-item><b-link href="#" @click="startHowTo('742118627?h=a7d11c42a6', 'Contract Length')">Contract Length</b-link></b-dropdown-item>
                    <b-dropdown-item><b-link href="#" @click="startHowTo('735880306?h=c3870991de', 'Ramp Up Period')">Ramp Up Period</b-link></b-dropdown-item>
                    <b-dropdown-item><b-link href="#" @click="startHowTo('735880294?h=07085fc717', 'Days on Market')">Days On Market</b-link></b-dropdown-item>
                  </b-dropdown>
                </div>
                <label class="form-control-label">Average Contract to Close Length <span id="contract-to-close"><i class="fas fa-question-circle"></i></span></label>
                <b-tooltip target="contract-to-close" triggers="hover" variant="primary">
                  If unsure, input 45 days. This can be edited in the portal.
                </b-tooltip>
                <base-input type="number"
                            min="0"
                            max="365"
                            rules="required"
                            name="Contract Length"
                            v-model="contractLength"
                            helperText="How many days on average does it take in your market to go from contract accepted to contract closed?">
                </base-input>

                <label class="form-control-label">Ramp Up Period <span id="ramp-up-period"><i class="fas fa-question-circle"></i></span></label>
                <b-tooltip target="ramp-up-period" triggers="hover" variant="primary">
                  If unsure, input 10 days. This can be edited in the portal.
                </b-tooltip>
                <base-input type="number"
                            min="0"
                            max="365"
                            rules="required"
                            name="Ramp Up"
                            v-model="rampUp"
                            helperText="How many days on average does it take to go from listing agreement signed to day one on the market?">
                </base-input>

                <label class="form-control-label">Average Days On Market (DOM) <span id="days-on-market"><i class="fas fa-question-circle"></i></span></label>
                <b-tooltip target="days-on-market" triggers="hover" variant="primary">
                  If unsure, input 14 days. This can be edited in the portal.
                </b-tooltip>
                <base-input type="number"
                            min="0"
                            max="365"
                            rules="required"
                            name="DOM"
                            v-model="dom"
                            helperText="How many days on average does it take to go from day one on market to contract accepted for your listings?">
                </base-input>
                <b-button block variant="success" @click="updateBusinessInfo">Team Information <i class="fas fa-angle-double-right"></i></b-button>
              </div>
              <div v-show="currentstep == 2">
                <members></members>
                <users></users>
                <b-button block variant="success" @click="completeOnboarding">Complete Onboarding <i class="fas fa-check"></i></b-button>
              </div>
            </b-form>
          </validation-observer>

        </b-card-body>
      </b-card>
    </b-container>
    <how-to-modal :source="howToVideo" :video_title="howToTitle"></how-to-modal>
  </div>
</template>

<script>
import axios from 'axios';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import { BaseProgress } from '@/components';
import {Select, Option} from 'element-ui';
import errorsMixin from '@/mixins/errors-mixin';
import Members from '@/views/Portal/Team/Members';
import Users from '@/views/Portal/Team/Users';
import HowToModal from '@/views/Components/Modals/HowToModal';

export default {
  mixins: [errorsMixin],
  components: {
    BaseProgress,
    [Select.name]: Select,
    [Option.name]: Option,
    Members,
    Users,
    HowToModal
  },
  data() {
    return {
      year: new Date().getFullYear(),
      sections: [
        {
          id: 1,
          title: 'Business Information',
          icon: 'fa-building',
          steps: [1]
        },
        {
          id: 2,
          title: 'Team Information',
          icon: 'fa-users',
          steps: [2]
        }
      ],
      steps: [
        {
          step: 1,
          title: 'Business Information',
          icon: 'fa-building'
        },
        {
          step: 2,
          title: 'Member Information',
          icon: 'fa-users'
        }
      ],
      currentstep: 0,
      members: null,
      member: {
        name: "",
        title: "",
        email: ""
      },
      memberFields: ['name', 'title', 'email'],
      howToVideo: null,
      howToTitle: null,
    };
  },
  computed: {
    user() {
      return this.$store.getters['profile/user'].slug;
    },
    userRoute() {
      return this.$store.getters['profile/userRoute'];
    },
    title() {
      return this.steps.filter(step => {
        return step.step == this.currentstep;
      });
    },
    progress() {
      return ( this.currentstep / this.steps.length * 100);
    },
    team() {
      return this.$store.getters['teams/team'];
    },
    contractLength: {
      get() {
        return this.team.contract_length;
      },
      set(value) {
        return this.$store.commit('teams/SET_CONTRACT_LENGTH', value);
      }
    },
    rampUp: {
      get() {
        return this.team.ramp_up;
      },
      set(value) {
        return this.$store.commit('teams/SET_RAMP_UP', value);
      }
    },
    dom: {
      get() {
        return this.team.dom;
      },
      set(value) {
        return this.$store.commit('teams/SET_DOM', value);
      }
    }
  },
  methods: {
    current(section) {
      return section.steps.includes(this.currentstep) ? 'current' : '';
    },
    completed(section) {
      const lastStep = section.steps.slice(-1)[0];
      return this.currentstep > lastStep ? 'fa-check completed' : section.icon;
    },
    async completeOnboarding() {
      axios.post(this.userRoute + "/complete-setup")
      .then(response => {
        this.$store.dispatch("profile/user").then(() => {
          this.$store.dispatch("economicModel/get", {user: this.user, year: this.year});
          this.$store.dispatch("cos/get", {user: this.user, year: this.year});
          this.$router.push({ path: '/dashboard' });
        });
      });
    },
    async updateBusinessInfo() {
      axios.patch(this.userRoute + "/teams/" + this.team.slug, {
        contract_length: this.contractLength,
        ramp_up: this.rampUp,
        dom: this.dom
      })
      .then(response => {
        this.$store.dispatch('teams/get', {user: this.user});
        this.currentstep = this.currentstep + 1;
      })
      .catch(error => {
        this.error(error);
      });
    },
    async getMembers() {
      axios.get(this.userRoute + "/members")
      .then(response => {
        this.members = response.data;
      });
    },
    async addMember() {
      axios.post(this.userRoute + "/members", this.member)
      .then(response => {
        this.getMembers();
        this.clearMember();
      })
      .catch(error => {
        this.error(error);
      });
    },
    clearMember() {
      this.member.name = "";
      this.member.title = "";
      this.member.email = "";
    },
    startHowTo(video, title) {
      this.howToVideo = video;
      this.howToTitle = title;
      this.$bvModal.show('how-to-modal');
    }
  },
  created() {
    swal.fire({
      title: `Welcome to ClarityNOW!`,
      text: 'This is your last step to accessing your ClarityNOW portal. The following information you provide will help you track your goals and progress throughout the year. All of this information will be editable after you have completed your onboarding process.',
      showConfirmButton: true,
      confirmButtonText: 'Get Started',
      icon: 'info'
    }).then(result => {
      this.getMembers();
      this.currentstep = 1
    });
  }
};
</script>
<style>
.circle-icon {
  cursor: pointer;
  background: #cccccc;
  color: #ffffff;
  padding:20px;
  border-radius: 50%;
}
.circle-icon.completed {
  background: #009347;
}

.circle-icon.current {
  background: #0084FF;
}
</style>